import { makeVar } from "@apollo/client";

export const quotationsStatusVar = makeVar();
export const quotationsInitializedVar = makeVar();
export const generationInProgressStatusVar = makeVar();
